import linkhelper from '~/helpers/link';
import userModel from '~/models/usermodel';
let userInfo;
userModel.load().then((i) => {
    userInfo = i;
});
// eslint-disable-next-line complexity
export default function trackLink(event, id) {
    const el = linkhelper.validUrlClick(event);
    if (!el) {
        return;
    }
    const isResource = el.dataset.variant === 'resource';
    const trackThis = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.accounts_id) &&
        el.dataset.track &&
        id;
    if (trackThis) {
        /* eslint-disable camelcase */
        event.trackingInfo = {
            book: id,
            account_uuid: userInfo.uuid,
            [isResource ? 'resource_name' : 'book_format']: el.dataset.track,
            contact_id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.salesforce_contact_id
        };
        /* eslint-enable camelcase */
    }
}
